import React, { useState, useRef, useEffect } from "react";
import "../styles/ProjectCard.scss";
import { HoverComponent } from "./HoverComponent";

export function ProjectCard(props) {
  const [hover, setHover] = useState(false);

  const {
    projectImage,
    title,
    description,
    projectUrl,
    githubUrl,
  } = props.project;
  console.log(hover);
  return (
    <>
      <div
        className="project-card"
        onMouseEnter={() => {
          setHover(!hover);
        }}
        onMouseLeave={() => {
          setHover(!hover);
        }}
      >
        {hover && <HoverComponent project={props.project} />}

        <div className="image-container">
          <img src={projectImage} alt={title} />
        </div>
      </div>
    </>
  );
}
